import ReducerRegistry from '../base/redux/ReducerRegistry';
import { TOGGLE_SHARE_DIALOG } from './actionTypes';
const DEFAULT_STATE = {
    shareDialogVisible: false,
    isFirstTimeOpen: false
};
ReducerRegistry.register('features/share-room', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case TOGGLE_SHARE_DIALOG:
            return {
                ...state,
                shareDialogVisible: action.visible,
                isFirstTimeOpen: action.isFirstTime ?? state.isFirstTimeOpen
            };
    }
    return state;
});
